<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="full-height" style="padding: 20px; padding-bottom: 0; height: 100%">
    <el-tabs v-model="panel" @tab-click="handleClick">
      <el-tab-pane label="國家排序設定" name="country"> </el-tab-pane>
      <el-tab-pane label="熱門國家設定" name="hotC"> </el-tab-pane>
    </el-tabs>

    <div v-if="panel == 'hotC'" style="padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="success" @click="addData" :disabled="listLoading">建立</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column align="center" label="ID" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="panel == 'hotC'" align="center" label="圖片" width="300">
          <template slot-scope="scope">
            <el-image
              style="height: 50px"
              :src="scope.row.fileInfo[0].files[0].url"
              fit="contain"
              :preview-src-list="[scope.row.fileInfo[0].files[0].url]"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column v-if="panel == 'hotC'" align="center" label="標題" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>

        <el-table-column v-else align="center" label="標題" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.label }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="排序" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.sort }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="panel == 'hotC'" align="center" label="國家" width="350">
          <template slot-scope="scope">
            <p v-for="item in showCountry(scope.row.countries)" :key="item" style="margin: 2px 0px">
              {{ item }}
            </p>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editData(scope.row)">編輯</el-button>
          </template>
        </el-table-column>

        <el-table-column
          v-if="checkPermission(['ITA-DEV'])"
          label="刪除"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="handleDelete(scope)">刪除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      @closed="onDialogClosed"
      :title="'編輯'"
      :visible.sync="dialogFormVisible"
      width="50%"
      top="1%"
      style="border: 2px solid #ccc"
    >
      <el-card class="box-card" v-loading="formLoading" :body-style="{ border: '1px solid #ccc' }">
        <el-row>
          <el-col>
            <el-form ref="dynamicValidateForm" :model="formData">
              <el-form-item v-if="panel == 'hotC'" label="圖片" :label-width="formLabelWidth">
                <div>
                  <Upload
                    ref="uploadRef"
                    :accept="'.jpg,.jpeg,.png'"
                    :payload="formData"
                    :data-obj="fileObj"
                    :limit-file-count="1"
                    :limitText="'圖片尺寸:280x100，須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
                    :use-drag="false"
                    :action="'ToursCombine/saveHotCountry'"
                    :auto-upload="false"
                    :show-file-list="true"
                    :form-on-loading-parent="formLoading"
                    :btn-txt="'上傳'"
                    :before-file-list="
                      formData.fileInfo && formData.fileInfo.length
                        ? formData.fileInfo[0].files
                        : []
                    "
                  />
                </div>
              </el-form-item>

              <el-form-item
                v-if="panel == 'hotC'"
                label="標題"
                :label-width="formLabelWidth"
                prop="title"
                :rules="[
                  {
                    required: true,
                    message: '請輸入標題',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="formData.title" autocomplete="off" />
              </el-form-item>

              <el-form-item
                label="排序"
                :label-width="formLabelWidth"
                prop="sort"
                :rules="[
                  {
                    required: true,
                    message: '請輸入排序',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="formData.sort" autocomplete="off" type="number" />
              </el-form-item>

              <el-form-item
                v-if="panel == 'hotC'"
                label="國家"
                :label-width="formLabelWidth"
                prop="countries"
                :rules="[
                  { type: 'array', message: '型別錯誤', trigger: 'blur' },
                  { required: true, message: '請選擇國家', trigger: 'blur' },
                ]"
              >
                <el-cascader
                  v-model="formData.countries"
                  :options="cascaderCountryOptions"
                  style="width: 100%"
                  :props="{
                    multiple: true,
                    value: 'id',
                  }"
                  collapse-tags
                ></el-cascader>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-card>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveData('dynamicValidateForm')">儲 存</el-button>
        <el-button @click="onDialogClosed">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { getTravelAttractionsCascaderMenu } from '@/api/travel'
import { deleteHotCountry, getHotCountry, saveCountrySort, saveHotCountry } from '@/api/tcSetting'
import checkPermission from '@/utils/permission' // 权限判断函数
import Upload from '@/views/ita/components/fileUpload.vue'

var defaultHotCountryFormData = {
  id: null,
  fileInfo: [],
  sort: 99,
  title: '',
  countries: [],
}

export default {
  components: {
    Upload,
  },
  computed: {
    showCountry() {
      return function (value) {
        var strarray = []
        value.forEach(element => {
          var firest = this.cascaderCountryOptions.filter(x => {
            return x.id == element[0]
          })
          var sec = firest[0].children.filter(x => {
            return x.id == element[1]
          })
          var three = sec[0].children.filter(x => {
            return x.id == element[2]
          })
          var str = firest[0].label + ' / ' + sec[0].label + ' / ' + three[0].label
          strarray.push(str)
        })
        return strarray
      }
    },
  },
  data() {
    return {
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      formLoading: false,
      formData: {},
      panel: 'country',
      listLoading: false,
      list: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      options: [],
      cascaderCountryOptions: [],
    }
  },
  async created() {
    await this.getTravelAttractionsCascaderMenu()
  },
  methods: {
    checkPermission,
    async handleClick(tab, event) {
      this.list = []
      if (tab.name == 'country') {
        await this.getTravelAttractionsCascaderMenu()
      } else {
        await this.getSettingCountry()
      }
    },
    async getTravelAttractionsCascaderMenu() {
      this.listLoading = true
      let resp = await getTravelAttractionsCascaderMenu()
      this.listLoading = false
      this.list = resp.data
      this.cascaderCountryOptions = resp.data
      console.log(resp.data)
    },
    async getSettingCountry() {
      this.listLoading = true
      await getHotCountry()
        .then(resp => {
          this.list = resp.data
          this.listLoading = false
        })
        .catch()
    },
    addData() {
      let vm = this
      if (vm.panel == 'country') {
        //vm.formData = JSON.parse(JSON.stringify(defaultFormData));
      } else {
        vm.formData = JSON.parse(JSON.stringify(defaultHotCountryFormData))
      }
      vm.dialogFormVisible = true
    },
    editData(d) {
      console.log(d)
      const vm = this
      //複製物件
      let jData = JSON.parse(JSON.stringify(d))
      vm.formData = jData
      vm.dialogFormVisible = true
    },
    async saveData(formName) {
      console.log(this.formData)
      const vm = this
      if (!confirm(`確定要儲存資料?`)) {
        return false
      }
      let refUpload = this.$refs['uploadRef']
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (vm.panel == 'country') {
            vm.formLoading = true
            await saveCountrySort(vm.formData)
              .then(async response => {
                vm.dialogFormVisible = false
                vm.formLoading = false
                await this.getTravelAttractionsCascaderMenu()
              })
              .catch(error => {
                console.log(error)
              })
          } else {
            let payload = await refUpload.combineFileAndPayload()
            if (!payload) {
              alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
              return false
            }
            if (payload.fileInfo[0].files.length == 0 && payload.fileIDs.length == 0) {
              this.$message.error('請上傳圖片')
              return false
            }
            vm.formLoading = true
            await saveHotCountry(payload)
              .then(async resp => {
                refUpload.clearFiles()
                vm.dialogFormVisible = false
                vm.formLoading = false
                await vm.getSettingCountry()
              })
              .catch()
          }
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onDialogClosed() {
      let refUpload = this.$refs['uploadRef']
      if (refUpload != undefined) {
        refUpload.clearFiles()
      }
      this.$refs['dynamicValidateForm'].clearValidate()
      this.dialogFormVisible = false
    },
    handleDelete({ $index, row }) {
      console.log($index, row)
      this.$confirm('確定刪除該筆資料?', '警告', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.listLoading = true
          if (this.panel == 'country') {
            // await deleteIndexCarousel({ id: row.id });
            // await this.getList();
          } else {
            await deleteHotCountry({ id: row.id })
            await this.getSettingCountry()
          }

          this.listLoading = false

          this.$message({
            type: 'success',
            message: '刪除成功',
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
}
</script>
